export const AI_DEFAULT_MAX_QUERY_LIMIT = 5000;
//# sourceMappingURL=constants.js.map